"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = exports.WindowBlockedError = exports.detectDeviceBest = exports.triggerOnPage = exports.triggerIframe = exports.triggerRedirect = exports.InteractionModes = void 0;
exports.closeInteractionMode = closeInteractionMode;
exports.getPopup = getPopup;
const constants_1 = require("./constants");
Object.defineProperty(exports, "InteractionModes", { enumerable: true, get: function () { return constants_1.InteractionModes; } });
const triggerOnPage_1 = require("./triggerOnPage");
Object.defineProperty(exports, "triggerOnPage", { enumerable: true, get: function () { return triggerOnPage_1.triggerOnPage; } });
const triggerIframe_1 = require("./triggerIframe");
Object.defineProperty(exports, "triggerIframe", { enumerable: true, get: function () { return triggerIframe_1.triggerIframe; } });
const overlay_1 = __importDefault(require("./utils/overlay"));
const triggerRedirect_1 = require("./triggerRedirect");
Object.defineProperty(exports, "triggerRedirect", { enumerable: true, get: function () { return triggerRedirect_1.triggerRedirect; } });
const detectDeviceBest_1 = require("./utils/detectDeviceBest");
Object.defineProperty(exports, "detectDeviceBest", { enumerable: true, get: function () { return detectDeviceBest_1.detectDeviceBest; } });
const openPopUp_1 = require("./openPopUp");
Object.defineProperty(exports, "Popup", { enumerable: true, get: function () { return openPopUp_1.Popup; } });
Object.defineProperty(exports, "WindowBlockedError", { enumerable: true, get: function () { return openPopUp_1.WindowBlockedError; } });
function closeInteractionMode() {
    if (overlay_1.default.ACTIVE_OVERLAY)
        overlay_1.default.ACTIVE_OVERLAY.destroy();
    const popup = openPopUp_1.Popup.getInstance();
    if (popup.getOpenedWindow()) {
        popup.closeOpenedWindow();
    }
}
function getPopup() {
    return openPopUp_1.Popup.getInstance().getOpenedWindow();
}
